import {
  accessAuthHeaders,
  clearAccessToken,
  readAccessToken,
  writeAccessToken,
} from '../../lib/access-token-storage.js'

/**
 * Jeton d'accès à une proposition. Même mécanique que pour une demande de
 * réservation — seule la portée change (voir `access-token-storage.ts`).
 */
export const readQuoteToken = (responseId: string): null | string =>
  readAccessToken('quote', responseId)

export const writeQuoteToken = (responseId: string, token: string): void =>
  writeAccessToken('quote', responseId, token)

export const clearQuoteToken = (responseId: string): void => clearAccessToken('quote', responseId)

export const quoteAuthHeaders = (responseId: string): Record<string, string> =>
  accessAuthHeaders('quote', responseId)
